import * as yup from "yup";
import { nameof } from "core/util/nameof";
const FileDataInputSchema = yup.object().shape({
    data: yup.string(),
    fileName: yup.string(),
    fileSize: yup.number().required(),
});
export const Validate = () => {
    const schema = yup
        .object({
        SelectedToDoItem: yup
            .mixed()
            .required("Please select a subject"),
        SelectedAccount: yup
            .string()
            .when(nameof("SelectedToDoItem"), (values, schema) => {
            if (values.length !== 1) {
                throw new Error("Expected one value");
            }
            const [selectedToDoItem] = values;
            if (selectedToDoItem != null &&
                selectedToDoItem.SecureMessageType?.IsAccount) {
                return schema.required("Please select an account");
            }
            return schema;
        }),
        Message: yup.string().required("Please enter a message"),
        FileData: yup.array().of(FileDataInputSchema),
    })
        .defined();
    return schema;
};
